import axios from 'axios'
import { BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'
import { salvarCacheItinerariosAbertosVendaUrbana, carregarCacheItinerariosAbertosVendaUrbana } from '../../util/offlineStorage'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarItinerariosAbertosVendaUrbana (idEmpresa) {
  const url = `${URL}/vendas-urbanas/empresa/${idEmpresa}/itinerarios-abertos`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => {
      salvarCacheItinerariosAbertosVendaUrbana(idEmpresa, response.data)
      return dispatch({
        type: BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA,
        payload: response.data
      })
    }
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      const cache = carregarCacheItinerariosAbertosVendaUrbana(idEmpresa)
      return dispatch({ type: BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA, payload: cache || [] })
    }
    throw erro
  })
}
